import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function ZoneStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				d="M16 22.191C15.61 22.191 15.28 21.881 15.25 21.481C15.23 21.071 15.54 20.711 15.96 20.691C17.88 20.581 18.89 20.271 19.58 19.581C20.27 18.891 20.58 17.881 20.69 15.961C20.71 15.551 21.04 15.231 21.48 15.251C21.89 15.271 22.21 15.631 22.19 16.041C22.08 17.981 21.77 19.511 20.64 20.641C19.51 21.771 17.99 22.071 16.04 22.191C16.03 22.191 16.01 22.191 16 22.191ZM8 22.191C8 22.191 7.97 22.191 7.96 22.191C6.02 22.081 4.49 21.771 3.36 20.641C2.23 19.511 1.92 17.981 1.81 16.041C1.79 15.631 2.1 15.271 2.52 15.251C2.92 15.221 3.29 15.541 3.31 15.961C3.42 17.881 3.73 18.891 4.42 19.581C5.11 20.271 6.12 20.581 8.04 20.691C8.45 20.711 8.77 21.071 8.75 21.481C8.73 21.881 8.4 22.191 8 22.191ZM21.43 8.75097C21.04 8.75097 20.71 8.44097 20.68 8.04097C20.57 6.12097 20.26 5.11097 19.57 4.42097C18.88 3.73097 17.87 3.42097 15.95 3.31097C15.54 3.29097 15.22 2.93097 15.24 2.52097C15.26 2.11097 15.59 1.78097 16.04 1.81097C17.98 1.92097 19.51 2.23097 20.64 3.36097C21.77 4.49097 22.07 6.01097 22.19 7.96097C22.21 8.37097 21.9 8.73097 21.48 8.75097C21.46 8.75097 21.45 8.75097 21.44 8.75097H21.43ZM2.56 8.75097C2.56 8.75097 2.53 8.75097 2.52 8.75097C2.11 8.73097 1.79 8.37097 1.81 7.96097C1.92 6.02097 2.23 4.49097 3.36 3.36097C4.49 2.23097 6.01 1.93097 7.95 1.81097C8.38 1.78097 8.72 2.10097 8.74 2.52097C8.76 2.93097 8.45 3.29097 8.03 3.31097C6.11 3.42097 5.09 3.73097 4.41 4.42097C3.72 5.11097 3.41 6.12097 3.3 8.04097C3.28 8.44097 2.95 8.75097 2.55 8.75097H2.56Z"
				fill="currentColor"
			/>
			<path
				d="M12.01 12.501C11.46 12.501 11.01 12.051 11.01 11.501C11.01 10.951 11.45 10.501 12.01 10.501C12.56 10.501 13.01 10.951 13.01 11.501C13.01 12.051 12.56 12.501 12.01 12.501Z"
				fill="currentColor"
			/>
			<path
				d="M12 17.251C11.54 17.251 11.1 17.081 10.77 16.761L10.34 16.351C8.66 14.781 6.36 12.621 7.62 9.63097C8.35 7.91097 10.11 6.75097 12 6.75097C13.89 6.75097 15.66 7.91097 16.39 9.63097C17.66 12.631 15.34 14.801 13.65 16.381L13.24 16.761C12.91 17.081 12.47 17.251 12 17.251ZM12 8.25097C10.7 8.25097 9.49 9.04097 9 10.211C8.2 12.101 9.42 13.431 11.36 15.251L11.8 15.671C11.9 15.771 12.1 15.771 12.2 15.671L12.62 15.281C14.58 13.451 15.81 12.111 15.01 10.211C14.51 9.04097 13.31 8.25097 12.01 8.25097H12Z"
				fill="currentColor"
			/>
		</svg>
	);
}

ZoneStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default ZoneStrokeIcon;
